export default __webpack_public_path__ + "static/wallet2-0766f9c7688a099712da2feaae56b8c4.png";